import React from "react";
import { useDataTableHook } from "./data-table-hooks";

type ContextDataTable = ReturnType<typeof useDataTableHook<any, any>>;
export const DataTableContext = React.createContext<ContextDataTable | null>(
  null,
);

export function useContextDataTable() {
  const context = React.useContext(DataTableContext);

  if (!context) {
    throw new Error(
      "useContextDataTable must be used within a ContextDataTableProvider",
    );
  }

  return context;
}
